import axios from 'axios';
import httpClient from '../../shared/utils/http-client';

export default {
  async getLocale() {
    const response = await httpClient.get('/internal_api/locale.json', {
      transformResponse: [...axios.defaults.transformResponse],
    });

    return response.data;
  },
  async getDeviseLocale() {
    const response = await httpClient.get('/devise/locale.json', {
      transformResponse: [...axios.defaults.transformResponse],
    });

    return response.data;
  },
};
